const hasKey = (obj, key) => key in obj;
const forEachKey = (obj, callback) => Object.keys(obj).forEach(key => hasKey(obj, key) && callback(key));
const mapEachKey = (obj, callback) => Object.keys(obj).filter(key => hasKey(obj, key)).map(key => callback(key));
export { hasKey, forEachKey, mapEachKey };